export default __webpack_public_path__ + "static/media/pantry1-afterF-1440w.e1523026.avif";